import {
  HERBS_DATA,
  KEY_ITEMS_DATA,
  MATERIALS_DATA,
  MEDICINES_DATA,
} from "./data";

// 防具类型
export const BACKPACK_ITEMS = [
  {
    key: "Herbs",
    label: "草药",
    data: HERBS_DATA,
  },
  {
    key: "Medicines",
    label: "丹药",
    data: MEDICINES_DATA,
  },
  {
    key: "Materials",
    label: "材料",
    data: MATERIALS_DATA,
  },
  {
    key: "KeyItems",
    label: "细软",
    data: KEY_ITEMS_DATA,
  },
];
